export class Email {
  email: string;
  name?: string;
  $key?: string;

  constructor(email?: string, name?: string) {
    if (email) {
      this.email = email;
    }
    if (name) {
      this.name = name;
    }
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/email.ts